module.exports = "<% items.forEach(function(item) { %> <option value=\"<%= item.value %>\" <%= item.selected %>><%= item.text %></option> <% })%> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./web/WEB-INF/js/client/search/templates/review-value.template.html
// module id = 69
// module chunks = 2